import { sleep } from "../helpers/playerHelpers";
import { getDimensions } from "../helpers/productHelpers";

export default class ProductSelector {
  constructor(collectionName, options = {}) {
    this.collectionName = collectionName;
    this.enableCustomSizes = options.enableCustomSizes;
    this.recommendedSizeEnabled = options.recommendedSizeEnabled;
    this.usingCustomProduct = false;
  }

  loadProducts(callback) {
    $.getJSON(
      `/collections/${this.collectionName}/products.json`,
      (response) => {
        this.products = response.products;
        this.currentProduct = response.products[0];
        callback(response.products);
      }
    );
  }

  addToCart(items, callback, errorCallback) {
    fetch("/cart/add.js", {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items,
        success: callback,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(callback)
      .catch(errorCallback);
  }

  loadProduct(handle, callback = null, addToProducts = true) {
    $.getJSON(`/products/${handle}.json`, (response) => {
      if (addToProducts) {
        this.products.push(response.product);
        this.currentProduct = response.product;
      }

      callback(response.product);
    });
  }

  async loadProductsByHandles(handles, callback = null) {
    const products = [];
    handles.forEach((handle) => {
      this.loadProduct(
        handle,
        (product) => {
          products.push(product);
        },
        false
      );
    });
    while (products.length < handles.length) {
      await sleep(500);
    }
    products.sort((productA, productB) => {
      return getDimensions(productA)[0] - getDimensions(productB)[0];
    });
    callback(products);
  }

  changeToProduct(product, callback = null) {
    this.currentProduct = product;
    callback && callback(this.currentProduct);
    return this.currentProduct;
  }

  changeToProductById(id, callback = null) {
    this.currentProduct = this.products.find((product) => product.id === id);

    callback && callback(this.currentProduct);
    return this.currentProduct;
  }

  inverseOfCurrentProduct(callback = null) {
    let regex = /([0-9])+/gm;
    let canvasDimensions = this.currentProduct.title.match(regex).reverse();

    let inverse = this.products.find((product) => {
      let dimensions = product.title.match(regex);

      return (
        canvasDimensions[0] == dimensions[0] &&
        canvasDimensions[1] == dimensions[1]
      );
    });

    if (!inverse && this.enableCustomSizes) {
      let handle = `${canvasDimensions[0]}x${canvasDimensions[1]}-canvas-photo-print`;
      this.usingCustomProduct = true;
      return this.loadProduct(handle, callback, false);
    }

    this.usingCustomProduct = false;
    inverse = inverse || this.currentProduct;
    this.currentProduct = inverse;
    callback && callback(this.currentProduct);
    return this.currentProduct;
  }

  titleForProduct(product) {
    let canvasDimensions = this.dimensionsOfProduct(product);

    if (this.isCurrentProductTriptych()) {
      const style = product.title.includes("Cozy") ? "Cozy" : "Classic";
      const subStyle = product.title.includes("Flow") ? " Flow" : "";
      return `${canvasDimensions[0]}" x ${canvasDimensions[1]}" ${style}${subStyle}`;
    } else {
      return `${canvasDimensions[0]}" x ${canvasDimensions[1]}"`;
    }
  }

  dimensionsOfProduct(product) {
    // TODO revisit
    // let regex = /([0-9]|\.)+/gm;
    // const sku = product.variants[0].sku;
    // if (sku.split("-")[1] == "COL") {
    //   return product.handle.split("-")[2].match(regex);
    // } else {
    //   return sku.match(regex).slice(0,2);
    // }
    let regex = /([0-9])+/gm;
    return product.title.match(regex);
  }

  dimensionsOfCurrentProduct() {
    return this.dimensionsOfProduct(this.currentProduct);
  }

  isCurrentProductTriptych() {
    return this.currentProduct.title.includes("Triptych");
  }

  customSingleOptions() {
    let html = `<select class="size_select" name="height_select" id="height_select">`;
    html += `<option value="0" disabled="" selected="selected">H"</option>`;

    for (var h = 8; h < 41; h++) {
      html += `<option value="${h}">${h}"</option>`;
    }

    html += `</select>`;
    html += `<span class="x_symbol">x</span>`;
    html += `<select class="size_select" name="width_select" id="width_select">`;
    html += `<option value="0" disabled="" selected="selected">W"</option>`;

    for (var w = 8; w < 41; w++) {
      html += `<option value="${w}">${w}"</option>`;
    }

    html += `</select>`;

    return html;
  }

  productDimensionsArray(products) {
    return products.map((product) => {
      const dimensions = this.dimensionsOfProduct(product);
      const height = parseInt(dimensions[0]);
      const width = parseInt(dimensions[1]);

      return {
        handle: product.handle,
        height: height,
        width: width,
        ratio: height / width,
        orientation: height > width,
      };
    });
  }
}
